export const setPageTitle = (title = "Welcome") => document.title = `${title} - SmartMSI`;